
import { Link } from "react-router-dom";
import { LucideIcon } from "lucide-react";

interface NavigationLinkProps {
  path: string;
  icon: LucideIcon;
  label: string;
  isActive: boolean;
  onClick?: () => void;
  className?: string;
}

export const NavigationLink = ({ 
  path, 
  icon: Icon, 
  label, 
  isActive, 
  onClick, 
  className 
}: NavigationLinkProps) => {
  const baseClasses = "flex items-center transition-colors";
  const activeClasses = isActive
    ? "text-primary-foreground bg-primary"
    : "text-gray-600 hover:bg-gray-100";
  
  return (
    <Link
      to={path}
      onClick={onClick}
      className={`${baseClasses} ${activeClasses} ${className}`}
    >
      <Icon className="w-5 h-5" />
      <span className="ml-3 md:ml-2">{label}</span>
    </Link>
  );
};
